<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ !!tagName ? $t("tiktok.settings.edit_tag") : $t("tiktok.settings.add_tag") }}
            <div class="number-block">
                <img class="icon" :src="tiktokIcon"/>
                <span>{{ info?.username }}</span>
            </div>
        </h3>

        <form class="content" @submit.prevent="actionTag">
            <div class="field">
                <p class="subtitle">{{ $t("tiktok.settings.tag_name_label") }}</p>
                <input
                    v-model="inputTag"
                    type="text"
                    :class="{ input_error: !!error }"
                    :placeholder="$t('tags.name_placeholder')"
                />
                <div class="input-errors" :class="{ 'is-shown': !!error }">{{ error }}</div>
            </div>

            <div class="action_container">
                <ButtonLoading
                    type="submit"
                    :loading="button.loading"
                    :disabled="button.disabled || !isSubmittable"
                >
                    {{ !!tagName ? $t("common.save") : $t("common.add") }}
                </ButtonLoading>
            </div>
        </form>
    </div>
</template>



<script setup>
// core
import {ref, computed, getCurrentInstance} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const store = useStore();
const tiktokIcon = require("@/assets/icons/tiktok.svg").default;
const {proxy} = getCurrentInstance();
const {t: $t} = useI18n();

const button = ref({
    loading: false,
    disabled: false,
});

const inputTag = ref("");

const TAG_MAX_LENGTH = 20;

const error = computed(() => {
    const value = inputTag.value || "";
    if (!value.trim()) return "";
    if (value.length > TAG_MAX_LENGTH) return $t("validation.max", {length: TAG_MAX_LENGTH});
    if (!/^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ0-9]*$/.test(value)) return $t("validation.alphanumeric");
    return "";
});

const isSubmittable = computed(
    () => !!inputTag.value?.trim() && !error.value && inputTag.value !== tagName.value
);

const tagName = computed(() => {
    inputTag.value = store.state.dialogParams?.info?.tags?.[0]?.name;
    return store.state.dialogParams?.info?.tags?.[0]?.name;
});

const tagId = computed(() => store.state.dialogParams?.info?.tags?.[0]?.id || null);
const info = computed(() => store.state.dialogParams?.info);

const onToggleLoadingButton = () => {
    button.value.loading = !button.value.loading;
    button.value.disabled = button.value.loading;
};

const closeOrReturn = (tags) => {
    if (!!store.getters.getNextDialog) {
        store.commit("setTagsToDialogParams", tags);
        store.commit("setDialog", store.getters.getNextDialog);
        store.commit("setNextDialog", "");
    } else {
        store.commit("closeDialog");
    }
};

const actionTag = async () => {
    if (!isSubmittable.value) return;

    const payload = {
        userId: info.value.user_id,
        name: inputTag.value,
        moshaToast: proxy.$moshaToast,
    };

    onToggleLoadingButton();

    try {
        if (!!tagId.value) {
            const res = await store.dispatch("tiktok/editTag", {
                ...payload,
                id: tagId.value,
            });
            closeOrReturn([{name: res.data?.name ?? inputTag.value, id: tagId.value}]);
        } else {
            const res = await store.dispatch("tiktok/addTag", payload);
            closeOrReturn([res.data]);
        }

        await store.dispatch("tiktok/loadAccounts", {
            visibility: info.value.visibility,
        });
    } catch (e) {
        onToggleLoadingButton();
    }
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
